module.exports = __webpack_public_path__ + "img/GB11.e6f878f5.jpg";